export default "__VITE_ASSET__qEpq2EVj__"